import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiSimulatorQuestions extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}